import { forwardRef } from 'react'
import { SnackbarComponent } from '../index'
import { CloseIcon } from '$common/icons/close'
import { ApproveIcon } from '$common/icons/approve'

interface Props {
  text: string | JSX.Element
  close: () => unknown
  icon?: JSX.Element
}

export const InfoSnackbar = forwardRef(function InfoSnackbar(
  { text, icon, close }: Props,
  ref,
) {
  return (
    <SnackbarComponent
      ref={ref}
      text={text}
      button={<CloseIcon />}
      icon={icon}
      onClick={close}
    />
  )
})

InfoSnackbar.defaultProps = {
  icon: <ApproveIcon sx={{ width: '24px', height: '24px' }} />,
}
